module.exports = __webpack_public_path__ + "static/media/social_linkedin.d0bd6b51.png";